<script>
  import Profile from './index.vue';

  export default Profile;
</script>
